import { PropertyUnitIntendedUse } from '../domain/types';

export const propertyUnitIntendedUseLabels: Record<PropertyUnitIntendedUse, string> = {
  RESIDENTIAL: 'Residenziale',
  COMMERCIAL: 'Commerciale',
  LAND: 'Terreno',
  WAREHOUSE: 'Deposito',
  SHELTER: 'Rimessa',
};
